module.exports = [
	{
		"segment": "Bottom",
		"forecast_year": "2030",
		"forecast_max": 950144.4,
		"unit": "Number of Adults, '000s",
		"current_max": 818072.8,
		"metrics": [
			{
				"metricValueCurrent": 5786.6,
				"metricValueForecast": 4802.2,
				"latlng": [
					40.143105,
					47.576927
				],
				"country": "Azerbaijan"
			},
			{
				"metricValueCurrent": 23358.2,
				"metricValueForecast": 26462.4,
				"latlng": [
					28.033886,
					1.659626
				],
				"country": "Algeria"
			},
			{
				"metricValueCurrent": 20740.9,
				"metricValueForecast": 22549.7,
				"latlng": [
					-38.416097,
					-63.61667199999999
				],
				"country": "Argentina"
			},
			{
				"metricValueCurrent": 2008.6,
				"metricValueForecast": 1662.8,
				"latlng": [
					47.516231,
					14.550072
				],
				"country": "Austria"
			},
			{
				"metricValueCurrent": 1397.4,
				"metricValueForecast": 1579.9,
				"latlng": [
					-25.274398,
					133.775136
				],
				"country": "Australia"
			},
			{
				"metricValueCurrent": 1181.1,
				"metricValueForecast": 1257.7,
				"latlng": [
					50.503887,
					4.469936
				],
				"country": "Belgium"
			},
			{
				"metricValueCurrent": 244.7,
				"metricValueForecast": 194,
				"latlng": [
					26.0667,
					50.5577
				],
				"country": "Bahrain"
			},
			{
				"metricValueCurrent": 6663.4,
				"metricValueForecast": 4434,
				"latlng": [
					53.709807,
					27.953389
				],
				"country": "Belarus"
			},
			{
				"metricValueCurrent": 121152.2,
				"metricValueForecast": 121032.7,
				"latlng": [
					-14.235004,
					-51.92528
				],
				"country": "Brazil"
			},
			{
				"metricValueCurrent": 2405.1,
				"metricValueForecast": 1195.5,
				"latlng": [
					43.915886,
					17.679076
				],
				"country": "Bosnia"
			},
			{
				"metricValueCurrent": 3342.3,
				"metricValueForecast": 1180.8,
				"latlng": [
					42.733883,
					25.48583
				],
				"country": "Bulgaria"
			},
			{
				"metricValueCurrent": 5889.4,
				"metricValueForecast": 6450,
				"latlng": [
					-16.290154,
					-63.58865299999999
				],
				"country": "Bolivia"
			},
			{
				"metricValueCurrent": 4724.7,
				"metricValueForecast": 4422.2,
				"latlng": [
					56.130366,
					-106.346771
				],
				"country": "Canada"
			},
			{
				"metricValueCurrent": 953.2,
				"metricValueForecast": 977.4,
				"latlng": [
					46.818188,
					8.227511999999999
				],
				"country": "Switzerland"
			},
			{
				"metricValueCurrent": 6608.8,
				"metricValueForecast": 5067.9,
				"latlng": [
					-35.675147,
					-71.542969
				],
				"country": "Chile"
			},
			{
				"metricValueCurrent": 686506.2,
				"metricValueForecast": 368978.8,
				"latlng": [
					35.86166,
					104.195397
				],
				"country": "China"
			},
			{
				"metricValueCurrent": 23682.9,
				"metricValueForecast": 15434.7,
				"latlng": [
					4.570868,
					-74.297333
				],
				"country": "Colombia"
			},
			{
				"metricValueCurrent": 1639.8,
				"metricValueForecast": 740.7,
				"latlng": [
					45.1,
					15.2
				],
				"country": "Croatia"
			},
			{
				"metricValueCurrent": 3021.8,
				"metricValueForecast": 2615.3,
				"latlng": [
					49.81749199999999,
					15.472962
				],
				"country": "Czech Rep"
			},
			{
				"metricValueCurrent": 13841.3,
				"metricValueForecast": 11340.8,
				"latlng": [
					51.165691,
					10.451526
				],
				"country": "Germany"
			},
			{
				"metricValueCurrent": 1296.4,
				"metricValueForecast": 1234,
				"latlng": [
					56.26392,
					9.501785
				],
				"country": "Denmark"
			},
			{
				"metricValueCurrent": 3269.1,
				"metricValueForecast": 2257.4,
				"latlng": [
					18.735693,
					-70.162651
				],
				"country": "Dominican Rep"
			},
			{
				"metricValueCurrent": 7644.5,
				"metricValueForecast": 9324.7,
				"latlng": [
					-1.831239,
					-78.18340599999999
				],
				"country": "Ecuador"
			},
			{
				"metricValueCurrent": 49504.8,
				"metricValueForecast": 62988.8,
				"latlng": [
					26.820553,
					30.802498
				],
				"country": "Egypt"
			},
			{
				"metricValueCurrent": 5953.5,
				"metricValueForecast": 4538,
				"latlng": [
					40.46366700000001,
					-3.74922
				],
				"country": "Spain"
			},
			{
				"metricValueCurrent": 353.1,
				"metricValueForecast": 168,
				"latlng": [
					58.595272,
					25.013607
				],
				"country": "Estonia"
			},
			{
				"metricValueCurrent": 922.1,
				"metricValueForecast": 929.1,
				"latlng": [
					61.92410999999999,
					25.748151
				],
				"country": "Finland"
			},
			{
				"metricValueCurrent": 7434.8,
				"metricValueForecast": 6901.8,
				"latlng": [
					46.227638,
					2.213749
				],
				"country": "France"
			},
			{
				"metricValueCurrent": 7147.6,
				"metricValueForecast": 7155.2,
				"latlng": [
					55.378051,
					-3.435973
				],
				"country": "United Kingdom"
			},
			{
				"metricValueCurrent": 2265.6,
				"metricValueForecast": 1001.7,
				"latlng": [
					42.315407,
					43.35689199999999
				],
				"country": "Georgia"
			},
			{
				"metricValueCurrent": 1961.2,
				"metricValueForecast": 1433.9,
				"latlng": [
					39.074208,
					21.824312
				],
				"country": "Greece"
			},
			{
				"metricValueCurrent": 6916.8,
				"metricValueForecast": 6838.3,
				"latlng": [
					15.783471,
					-90.23075899999999
				],
				"country": "Guatemala"
			},
			{
				"metricValueCurrent": 1293.5,
				"metricValueForecast": 1110,
				"latlng": [
					22.396428,
					114.109497
				],
				"country": "Hong Kong"
			},
			{
				"metricValueCurrent": 3347.9,
				"metricValueForecast": 2256.3,
				"latlng": [
					47.162494,
					19.503304
				],
				"country": "Hungary"
			},
			{
				"metricValueCurrent": 154238,
				"metricValueForecast": 155798.8,
				"latlng": [
					-0.789275,
					113.921327
				],
				"country": "Indonesia"
			},
			{
				"metricValueCurrent": 568.5,
				"metricValueForecast": 535.4,
				"latlng": [
					53.41291,
					-8.24389
				],
				"country": "Ireland"
			},
			{
				"metricValueCurrent": 818072.8,
				"metricValueForecast": 950144.4,
				"latlng": [
					20.593684,
					78.96288
				],
				"country": "India"
			},
			{
				"metricValueCurrent": 51763.8,
				"metricValueForecast": 60590.1,
				"latlng": [
					32.427908,
					53.688046
				],
				"country": "Iran"
			},
			{
				"metricValueCurrent": 1115.3,
				"metricValueForecast": 1194.1,
				"latlng": [
					31.046051,
					34.851612
				],
				"country": "Israel"
			},
			{
				"metricValueCurrent": 6157.5,
				"metricValueForecast": 5536.6,
				"latlng": [
					41.87194,
					12.56738
				],
				"country": "Italy"
			},
			{
				"metricValueCurrent": 2477,
				"metricValueForecast": 2197.1,
				"latlng": [
					30.585164,
					36.238414
				],
				"country": "Jordan"
			},
			{
				"metricValueCurrent": 8359.6,
				"metricValueForecast": 8340.4,
				"latlng": [
					36.204824,
					138.252924
				],
				"country": "Japan"
			},
			{
				"metricValueCurrent": 10692.1,
				"metricValueForecast": 8305.3,
				"latlng": [
					48.019573,
					66.923684
				],
				"country": "Kazakhstan"
			},
			{
				"metricValueCurrent": 5115.7,
				"metricValueForecast": 4405.5,
				"latlng": [
					35.907757,
					127.766922
				],
				"country": "South Korea"
			},
			{
				"metricValueCurrent": 607.8,
				"metricValueForecast": 507.6,
				"latlng": [
					29.31166,
					47.481766
				],
				"country": "Kuwait"
			},
			{
				"metricValueCurrent": 23512.6,
				"metricValueForecast": 33632.4,
				"latlng": [
					-0.023559,
					37.906193
				],
				"country": "Kenya"
			},
			{
				"metricValueCurrent": 669.6,
				"metricValueForecast": 222.1,
				"latlng": [
					56.879635,
					24.603189
				],
				"country": "Latvia"
			},
			{
				"metricValueCurrent": 1182.6,
				"metricValueForecast": 379.4,
				"latlng": [
					55.169438,
					23.881275
				],
				"country": "Lithuania"
			},
			{
				"metricValueCurrent": 1271.6,
				"metricValueForecast": 897.8,
				"latlng": [
					41.608635,
					21.745275
				],
				"country": "Macedonia"
			},
			{
				"metricValueCurrent": 19466.3,
				"metricValueForecast": 17527.1,
				"latlng": [
					31.791702,
					-7.092619999999999
				],
				"country": "Morocco"
			},
			{
				"metricValueCurrent": 60744.8,
				"metricValueForecast": 58796.5,
				"latlng": [
					23.634501,
					-102.552784
				],
				"country": "Mexico"
			},
			{
				"metricValueCurrent": 15281.1,
				"metricValueForecast": 7375.9,
				"latlng": [
					4.210484,
					101.975766
				],
				"country": "Malaysia"
			},
			{
				"metricValueCurrent": 90906.9,
				"metricValueForecast": 135961.1,
				"latlng": [
					9.081999,
					8.675277
				],
				"country": "Nigeria"
			},
			{
				"metricValueCurrent": 2322.6,
				"metricValueForecast": 2404.4,
				"latlng": [
					52.132633,
					5.291265999999999
				],
				"country": "Netherlands"
			},
			{
				"metricValueCurrent": 902.8,
				"metricValueForecast": 974.1,
				"latlng": [
					60.47202399999999,
					8.468945999999999
				],
				"country": "Norway"
			},
			{
				"metricValueCurrent": 410,
				"metricValueForecast": 388.6,
				"latlng": [
					-40.900557,
					174.885971
				],
				"country": "New Zealand"
			},
			{
				"metricValueCurrent": 11691.6,
				"metricValueForecast": 16484.4,
				"latlng": [
					7.369721999999999,
					12.354722
				],
				"country": "Cameroon"
			},
			{
				"metricValueCurrent": 53713.7,
				"metricValueForecast": 48388.9,
				"latlng": [
					12.879721,
					121.774017
				],
				"country": "Philippines"
			},
			{
				"metricValueCurrent": 105840.5,
				"metricValueForecast": 114191.1,
				"latlng": [
					30.375321,
					69.34511599999999
				],
				"country": "Pakistan"
			},
			{
				"metricValueCurrent": 20253.7,
				"metricValueForecast": 11146.7,
				"latlng": [
					51.919438,
					19.145136
				],
				"country": "Poland"
			},
			{
				"metricValueCurrent": 2694.4,
				"metricValueForecast": 1863.9,
				"latlng": [
					39.39987199999999,
					-8.224454
				],
				"country": "Portugal"
			},
			{
				"metricValueCurrent": 14638.8,
				"metricValueForecast": 12718.5,
				"latlng": [
					-9.189967,
					-75.015152
				],
				"country": "Peru"
			},
			{
				"metricValueCurrent": 205.7,
				"metricValueForecast": 285.2,
				"latlng": [
					25.354826,
					51.183884
				],
				"country": "Qatar"
			},
			{
				"metricValueCurrent": 1693.9,
				"metricValueForecast": 1099.9,
				"latlng": [
					9.748916999999999,
					-83.753428
				],
				"country": "Costa Rica"
			},
			{
				"metricValueCurrent": 11504.8,
				"metricValueForecast": 5335.1,
				"latlng": [
					45.943161,
					24.96676
				],
				"country": "Romania"
			},
			{
				"metricValueCurrent": 107414.6,
				"metricValueForecast": 90866,
				"latlng": [
					61.52401,
					105.318756
				],
				"country": "Russia"
			},
			{
				"metricValueCurrent": 8051.3,
				"metricValueForecast": 7870.2,
				"latlng": [
					23.885942,
					45.079162
				],
				"country": "Saudi Arabia"
			},
			{
				"metricValueCurrent": 2216.6,
				"metricValueForecast": 2059.5,
				"latlng": [
					60.12816100000001,
					18.643501
				],
				"country": "Sweden"
			},
			{
				"metricValueCurrent": 486.2,
				"metricValueForecast": 390.1,
				"latlng": [
					1.352083,
					103.819836
				],
				"country": "Singapore"
			},
			{
				"metricValueCurrent": 1534.3,
				"metricValueForecast": 707.9,
				"latlng": [
					48.669026,
					19.699024
				],
				"country": "Slovakia"
			},
			{
				"metricValueCurrent": 456.8,
				"metricValueForecast": 297.5,
				"latlng": [
					46.151241,
					14.995463
				],
				"country": "Slovenia"
			},
			{
				"metricValueCurrent": 43429.2,
				"metricValueForecast": 35901.9,
				"latlng": [
					15.870032,
					100.992541
				],
				"country": "Thailand"
			},
			{
				"metricValueCurrent": 3153.3,
				"metricValueForecast": 1951.6,
				"latlng": [
					38.969719,
					59.556278
				],
				"country": "Turkmenistan"
			},
			{
				"metricValueCurrent": 36193.2,
				"metricValueForecast": 27399.9,
				"latlng": [
					38.963745,
					35.243322
				],
				"country": "Turkey"
			},
			{
				"metricValueCurrent": 5401.5,
				"metricValueForecast": 4425.8,
				"latlng": [
					33.886917,
					9.537499
				],
				"country": "Tunisia"
			},
			{
				"metricValueCurrent": 2454.9,
				"metricValueForecast": 1805.6,
				"latlng": [
					23.69781,
					120.960515
				],
				"country": "Taiwan"
			},
			{
				"metricValueCurrent": 1536.6,
				"metricValueForecast": 1144.2,
				"latlng": [
					23.424076,
					53.847818
				],
				"country": "United Arab Emirates"
			},
			{
				"metricValueCurrent": 36286.5,
				"metricValueForecast": 32617.3,
				"latlng": [
					48.379433,
					31.16558
				],
				"country": "Ukraine"
			},
			{
				"metricValueCurrent": 63459.3,
				"metricValueForecast": 54839.8,
				"latlng": [
					37.09024,
					-95.712891
				],
				"country": "USA"
			},
			{
				"metricValueCurrent": 869.2,
				"metricValueForecast": 475.7,
				"latlng": [
					-32.522779,
					-55.765835
				],
				"country": "Uruguay"
			},
			{
				"metricValueCurrent": 19431.7,
				"metricValueForecast": 22607.7,
				"latlng": [
					41.377491,
					64.585262
				],
				"country": "Uzbekistan"
			},
			{
				"metricValueCurrent": 62076.5,
				"metricValueForecast": 57401.4,
				"latlng": [
					14.058324,
					108.277199
				],
				"country": "Vietnam"
			},
			{
				"metricValueCurrent": 25816.9,
				"metricValueForecast": 21369.3,
				"latlng": [
					-30.559482,
					22.937506
				],
				"country": "South Africa"
			},
			{
				"metricValueCurrent": 4581.5,
				"metricValueForecast": 2257.1,
				"latlng": [
					44.016521,
					21.005859
				],
				"country": "Serbia"
			}
		],
		"current_year": "2016"
	},
	{
		"segment": "Middle",
		"forecast_year": "2030",
		"forecast_max": 666688.8,
		"unit": "Number of Adults, '000s",
		"current_max": 369457.5,
		"metrics": [
			{
				"metricValueCurrent": 1271.3,
				"metricValueForecast": 3124.7,
				"latlng": [
					40.143105,
					47.576927
				],
				"country": "Azerbaijan"
			},
			{
				"metricValueCurrent": 3496.7,
				"metricValueForecast": 6858.5,
				"latlng": [
					28.033886,
					1.659626
				],
				"country": "Algeria"
			},
			{
				"metricValueCurrent": 9209.1,
				"metricValueForecast": 12364.2,
				"latlng": [
					-38.416097,
					-63.61667199999999
				],
				"country": "Argentina"
			},
			{
				"metricValueCurrent": 3333,
				"metricValueForecast": 3314.5,
				"latlng": [
					47.516231,
					14.550072
				],
				"country": "Austria"
			},
			{
				"metricValueCurrent": 4959,
				"metricValueForecast": 3188.9,
				"latlng": [
					-25.274398,
					133.775136
				],
				"country": "Australia"
			},
			{
				"metricValueCurrent": 3089,
				"metricValueForecast": 2083.3,
				"latlng": [
					50.503887,
					4.469936
				],
				"country": "Belgium"
			},
			{
				"metricValueCurrent": 626.4,
				"metricValueForecast": 783.3,
				"latlng": [
					26.0667,
					50.5577
				],
				"country": "Bahrain"
			},
			{
				"metricValueCurrent": 968.6,
				"metricValueForecast": 2871.9,
				"latlng": [
					53.709807,
					27.953389
				],
				"country": "Belarus"
			},
			{
				"metricValueCurrent": 28275.3,
				"metricValueForecast": 51862.2,
				"latlng": [
					-14.235004,
					-51.92528
				],
				"country": "Brazil"
			},
			{
				"metricValueCurrent": 755.6,
				"metricValueForecast": 1786.7,
				"latlng": [
					43.915886,
					17.679076
				],
				"country": "Bosnia"
			},
			{
				"metricValueCurrent": 2487,
				"metricValueForecast": 3566.6,
				"latlng": [
					42.733883,
					25.48583
				],
				"country": "Bulgaria"
			},
			{
				"metricValueCurrent": 808,
				"metricValueForecast": 2230.9,
				"latlng": [
					-16.290154,
					-63.58865299999999
				],
				"country": "Bolivia"
			},
			{
				"metricValueCurrent": 11345.1,
				"metricValueForecast": 8886.4,
				"latlng": [
					56.130366,
					-106.346771
				],
				"country": "Canada"
			},
			{
				"metricValueCurrent": 1945,
				"metricValueForecast": 1662.6,
				"latlng": [
					46.818188,
					8.227511999999999
				],
				"country": "Switzerland"
			},
			{
				"metricValueCurrent": 6200.7,
				"metricValueForecast": 8719.9,
				"latlng": [
					-35.675147,
					-71.542969
				],
				"country": "Chile"
			},
			{
				"metricValueCurrent": 369457.5,
				"metricValueForecast": 666688.8,
				"latlng": [
					35.86166,
					104.195397
				],
				"country": "China"
			},
			{
				"metricValueCurrent": 10096.2,
				"metricValueForecast": 21882.5,
				"latlng": [
					4.570868,
					-74.297333
				],
				"country": "Colombia"
			},
			{
				"metricValueCurrent": 1684.9,
				"metricValueForecast": 2124.7,
				"latlng": [
					45.1,
					15.2
				],
				"country": "Croatia"
			},
			{
				"metricValueCurrent": 5054.1,
				"metricValueForecast": 5310.9,
				"latlng": [
					49.81749199999999,
					15.472962
				],
				"country": "Czech Rep"
			},
			{
				"metricValueCurrent": 31085.1,
				"metricValueForecast": 24576.5,
				"latlng": [
					51.165691,
					10.451526
				],
				"country": "Germany"
			},
			{
				"metricValueCurrent": 1466.1,
				"metricValueForecast": 1011.1,
				"latlng": [
					56.26392,
					9.501785
				],
				"country": "Denmark"
			},
			{
				"metricValueCurrent": 3050.3,
				"metricValueForecast": 4751.5,
				"latlng": [
					18.735693,
					-70.162651
				],
				"country": "Dominican Rep"
			},
			{
				"metricValueCurrent": 2940,
				"metricValueForecast": 4219.3,
				"latlng": [
					-1.831239,
					-78.18340599999999
				],
				"country": "Ecuador"
			},
			{
				"metricValueCurrent": 3847.4,
				"metricValueForecast": 7354.8,
				"latlng": [
					26.820553,
					30.802498
				],
				"country": "Egypt"
			},
			{
				"metricValueCurrent": 22545.1,
				"metricValueForecast": 16319.4,
				"latlng": [
					40.46366700000001,
					-3.74922
				],
				"country": "Spain"
			},
			{
				"metricValueCurrent": 602.6,
				"metricValueForecast": 570.5,
				"latlng": [
					58.595272,
					25.013607
				],
				"country": "Estonia"
			},
			{
				"metricValueCurrent": 1981.3,
				"metricValueForecast": 1459.5,
				"latlng": [
					61.92410999999999,
					25.748151
				],
				"country": "Finland"
			},
			{
				"metricValueCurrent": 16257.3,
				"metricValueForecast": 8879.5,
				"latlng": [
					46.227638,
					2.213749
				],
				"country": "France"
			},
			{
				"metricValueCurrent": 16723.5,
				"metricValueForecast": 10901.5,
				"latlng": [
					55.378051,
					-3.435973
				],
				"country": "United Kingdom"
			},
			{
				"metricValueCurrent": 662,
				"metricValueForecast": 1603.6,
				"latlng": [
					42.315407,
					43.35689199999999
				],
				"country": "Georgia"
			},
			{
				"metricValueCurrent": 5454,
				"metricValueForecast": 4436.6,
				"latlng": [
					39.074208,
					21.824312
				],
				"country": "Greece"
			},
			{
				"metricValueCurrent": 2450,
				"metricValueForecast": 6099,
				"latlng": [
					15.783471,
					-90.23075899999999
				],
				"country": "Guatemala"
			},
			{
				"metricValueCurrent": 2810.6,
				"metricValueForecast": 2555.8,
				"latlng": [
					22.396428,
					114.109497
				],
				"country": "Hong Kong"
			},
			{
				"metricValueCurrent": 4413.8,
				"metricValueForecast": 4893.8,
				"latlng": [
					47.162494,
					19.503304
				],
				"country": "Hungary"
			},
			{
				"metricValueCurrent": 19459.8,
				"metricValueForecast": 51102,
				"latlng": [
					-0.789275,
					113.921327
				],
				"country": "Indonesia"
			},
			{
				"metricValueCurrent": 1507.1,
				"metricValueForecast": 956.8,
				"latlng": [
					53.41291,
					-8.24389
				],
				"country": "Ireland"
			},
			{
				"metricValueCurrent": 36314.6,
				"metricValueForecast": 117117.9,
				"latlng": [
					20.593684,
					78.96288
				],
				"country": "India"
			},
			{
				"metricValueCurrent": 5964.4,
				"metricValueForecast": 7682.2,
				"latlng": [
					32.427908,
					53.688046
				],
				"country": "Iran"
			},
			{
				"metricValueCurrent": 3079.3,
				"metricValueForecast": 3368.1,
				"latlng": [
					31.046051,
					34.851612
				],
				"country": "Israel"
			},
			{
				"metricValueCurrent": 20984.8,
				"metricValueForecast": 13505.2,
				"latlng": [
					41.87194,
					12.56738
				],
				"country": "Italy"
			},
			{
				"metricValueCurrent": 1621.2,
				"metricValueForecast": 3246.6,
				"latlng": [
					30.585164,
					36.238414
				],
				"country": "Jordan"
			},
			{
				"metricValueCurrent": 39430.3,
				"metricValueForecast": 27362.6,
				"latlng": [
					36.204824,
					138.252924
				],
				"country": "Japan"
			},
			{
				"metricValueCurrent": 1372,
				"metricValueForecast": 4857,
				"latlng": [
					48.019573,
					66.923684
				],
				"country": "Kazakhstan"
			},
			{
				"metricValueCurrent": 23458.1,
				"metricValueForecast": 16691.2,
				"latlng": [
					35.907757,
					127.766922
				],
				"country": "South Korea"
			},
			{
				"metricValueCurrent": 1779.8,
				"metricValueForecast": 1830.4,
				"latlng": [
					29.31166,
					47.481766
				],
				"country": "Kuwait"
			},
			{
				"metricValueCurrent": 954.8,
				"metricValueForecast": 3484.3,
				"latlng": [
					-0.023559,
					37.906193
				],
				"country": "Kenya"
			},
			{
				"metricValueCurrent": 882.3,
				"metricValueForecast": 968,
				"latlng": [
					56.879635,
					24.603189
				],
				"country": "Latvia"
			},
			{
				"metricValueCurrent": 1109,
				"metricValueForecast": 1280.9,
				"latlng": [
					55.169438,
					23.881275
				],
				"country": "Lithuania"
			},
			{
				"metricValueCurrent": 361,
				"metricValueForecast": 703.8,
				"latlng": [
					41.608635,
					21.745275
				],
				"country": "Macedonia"
			},
			{
				"metricValueCurrent": 3884.9,
				"metricValueForecast": 10045.7,
				"latlng": [
					31.791702,
					-7.092619999999999
				],
				"country": "Morocco"
			},
			{
				"metricValueCurrent": 23398,
				"metricValueForecast": 43186.8,
				"latlng": [
					23.634501,
					-102.552784
				],
				"country": "Mexico"
			},
			{
				"metricValueCurrent": 6236.2,
				"metricValueForecast": 17756.1,
				"latlng": [
					4.210484,
					101.975766
				],
				"country": "Malaysia"
			},
			{
				"metricValueCurrent": 1781.6,
				"metricValueForecast": 2267.9,
				"latlng": [
					9.081999,
					8.675277
				],
				"country": "Nigeria"
			},
			{
				"metricValueCurrent": 4083.6,
				"metricValueForecast": 2887.3,
				"latlng": [
					52.132633,
					5.291265999999999
				],
				"country": "Netherlands"
			},
			{
				"metricValueCurrent": 1655.4,
				"metricValueForecast": 1677.5,
				"latlng": [
					60.47202399999999,
					8.468945999999999
				],
				"country": "Norway"
			},
			{
				"metricValueCurrent": 1375.1,
				"metricValueForecast": 934.2,
				"latlng": [
					-40.900557,
					174.885971
				],
				"country": "New Zealand"
			},
			{
				"metricValueCurrent": 501,
				"metricValueForecast": 1735.2,
				"latlng": [
					7.369721999999999,
					12.354722
				],
				"country": "Cameroon"
			},
			{
				"metricValueCurrent": 9280,
				"metricValueForecast": 29071.4,
				"latlng": [
					12.879721,
					121.774017
				],
				"country": "Philippines"
			},
			{
				"metricValueCurrent": 7788.9,
				"metricValueForecast": 38654.6,
				"latlng": [
					30.375321,
					69.34511599999999
				],
				"country": "Pakistan"
			},
			{
				"metricValueCurrent": 10615.9,
				"metricValueForecast": 18129.6,
				"latlng": [
					51.919438,
					19.145136
				],
				"country": "Poland"
			},
			{
				"metricValueCurrent": 4481.5,
				"metricValueForecast": 4064.7,
				"latlng": [
					39.39987199999999,
					-8.224454
				],
				"country": "Portugal"
			},
			{
				"metricValueCurrent": 6005.1,
				"metricValueForecast": 11538.1,
				"latlng": [
					-9.189967,
					-75.015152
				],
				"country": "Peru"
			},
			{
				"metricValueCurrent": 1285.3,
				"metricValueForecast": 1551.6,
				"latlng": [
					25.354826,
					51.183884
				],
				"country": "Qatar"
			},
			{
				"metricValueCurrent": 1676.4,
				"metricValueForecast": 2558.5,
				"latlng": [
					9.748916999999999,
					-83.753428
				],
				"country": "Costa Rica"
			},
			{
				"metricValueCurrent": 4149.1,
				"metricValueForecast": 8411.5,
				"latlng": [
					45.943161,
					24.96676
				],
				"country": "Romania"
			},
			{
				"metricValueCurrent": 7582.4,
				"metricValueForecast": 19618.7,
				"latlng": [
					61.52401,
					105.318756
				],
				"country": "Russia"
			},
			{
				"metricValueCurrent": 11589,
				"metricValueForecast": 16150.3,
				"latlng": [
					23.885942,
					45.079162
				],
				"country": "Saudi Arabia"
			},
			{
				"metricValueCurrent": 3143.3,
				"metricValueForecast": 3176.5,
				"latlng": [
					60.12816100000001,
					18.643501
				],
				"country": "Sweden"
			},
			{
				"metricValueCurrent": 1995.2,
				"metricValueForecast": 1536.6,
				"latlng": [
					1.352083,
					103.819836
				],
				"country": "Singapore"
			},
			{
				"metricValueCurrent": 2670.4,
				"metricValueForecast": 3101.9,
				"latlng": [
					48.669026,
					19.699024
				],
				"country": "Slovakia"
			},
			{
				"metricValueCurrent": 1085.4,
				"metricValueForecast": 1048.6,
				"latlng": [
					46.151241,
					14.995463
				],
				"country": "Slovenia"
			},
			{
				"metricValueCurrent": 9324.9,
				"metricValueForecast": 17715.8,
				"latlng": [
					15.870032,
					100.992541
				],
				"country": "Thailand"
			},
			{
				"metricValueCurrent": 442.8,
				"metricValueForecast": 2133.3,
				"latlng": [
					38.969719,
					59.556278
				],
				"country": "Turkmenistan"
			},
			{
				"metricValueCurrent": 17739.6,
				"metricValueForecast": 33357.3,
				"latlng": [
					38.963745,
					35.243322
				],
				"country": "Turkey"
			},
			{
				"metricValueCurrent": 2659.1,
				"metricValueForecast": 4603.4,
				"latlng": [
					33.886917,
					9.537499
				],
				"country": "Tunisia"
			},
			{
				"metricValueCurrent": 10949.4,
				"metricValueForecast": 8030.1,
				"latlng": [
					23.69781,
					120.960515
				],
				"country": "Taiwan"
			},
			{
				"metricValueCurrent": 4905.2,
				"metricValueForecast": 5314,
				"latlng": [
					23.424076,
					53.847818
				],
				"country": "United Arab Emirates"
			},
			{
				"metricValueCurrent": 477.9,
				"metricValueForecast": 1465.5,
				"latlng": [
					48.379433,
					31.16558
				],
				"country": "Ukraine"
			},
			{
				"metricValueCurrent": 88930.9,
				"metricValueForecast": 81248.1,
				"latlng": [
					37.09024,
					-95.712891
				],
				"country": "USA"
			},
			{
				"metricValueCurrent": 1496.4,
				"metricValueForecast": 1732.6,
				"latlng": [
					-32.522779,
					-55.765835
				],
				"country": "Uruguay"
			},
			{
				"metricValueCurrent": 657.1,
				"metricValueForecast": 1497.6,
				"latlng": [
					41.377491,
					64.585262
				],
				"country": "Uzbekistan"
			},
			{
				"metricValueCurrent": 6283.2,
				"metricValueForecast": 20596.1,
				"latlng": [
					14.058324,
					108.277199
				],
				"country": "Vietnam"
			},
			{
				"metricValueCurrent": 9193.8,
				"metricValueForecast": 17221.5,
				"latlng": [
					-30.559482,
					22.937506
				],
				"country": "South Africa"
			},
			{
				"metricValueCurrent": 1244.4,
				"metricValueForecast": 2999,
				"latlng": [
					44.016521,
					21.005859
				],
				"country": "Serbia"
			}
		],
		"current_year": "2016"
	},
	{
		"segment": "Affluent",
		"forecast_year": "2030",
		"forecast_max": 110322.8,
		"unit": "Number of Adults, '000s",
		"current_max": 81279.2,
		"metrics": [
			{
				"metricValueCurrent": 56.8,
				"metricValueForecast": 192.7,
				"latlng": [
					40.143105,
					47.576927
				],
				"country": "Azerbaijan"
			},
			{
				"metricValueCurrent": 154,
				"metricValueForecast": 330.3,
				"latlng": [
					28.033886,
					1.659626
				],
				"country": "Algeria"
			},
			{
				"metricValueCurrent": 797.5,
				"metricValueForecast": 1170.6,
				"latlng": [
					-38.416097,
					-63.61667199999999
				],
				"country": "Argentina"
			},
			{
				"metricValueCurrent": 1702,
				"metricValueForecast": 2601.1,
				"latlng": [
					47.516231,
					14.550072
				],
				"country": "Austria"
			},
			{
				"metricValueCurrent": 11487,
				"metricValueForecast": 15566.8,
				"latlng": [
					-25.274398,
					133.775136
				],
				"country": "Australia"
			},
			{
				"metricValueCurrent": 4430.9,
				"metricValueForecast": 5560.9,
				"latlng": [
					50.503887,
					4.469936
				],
				"country": "Belgium"
			},
			{
				"metricValueCurrent": 78.8,
				"metricValueForecast": 178.1,
				"latlng": [
					26.0667,
					50.5577
				],
				"country": "Bahrain"
			},
			{
				"metricValueCurrent": 29.1,
				"metricValueForecast": 131.5,
				"latlng": [
					53.709807,
					27.953389
				],
				"country": "Belarus"
			},
			{
				"metricValueCurrent": 2132,
				"metricValueForecast": 4650.8,
				"latlng": [
					-14.235004,
					-51.92528
				],
				"country": "Brazil"
			},
			{
				"metricValueCurrent": 26.6,
				"metricValueForecast": 138.8,
				"latlng": [
					43.915886,
					17.679076
				],
				"country": "Bosnia"
			},
			{
				"metricValueCurrent": 133.8,
				"metricValueForecast": 581.8,
				"latlng": [
					42.733883,
					25.48583
				],
				"country": "Bulgaria"
			},
			{
				"metricValueCurrent": 39,
				"metricValueForecast": 153.2,
				"latlng": [
					-16.290154,
					-63.58865299999999
				],
				"country": "Bolivia"
			},
			{
				"metricValueCurrent": 11974.3,
				"metricValueForecast": 16881.1,
				"latlng": [
					56.130366,
					-106.346771
				],
				"country": "Canada"
			},
			{
				"metricValueCurrent": 3295.9,
				"metricValueForecast": 3886.8,
				"latlng": [
					46.818188,
					8.227511999999999
				],
				"country": "Switzerland"
			},
			{
				"metricValueCurrent": 898.8,
				"metricValueForecast": 2185.6,
				"latlng": [
					-35.675147,
					-71.542969
				],
				"country": "Chile"
			},
			{
				"metricValueCurrent": 26716,
				"metricValueForecast": 106601.5,
				"latlng": [
					35.86166,
					104.195397
				],
				"country": "China"
			},
			{
				"metricValueCurrent": 791,
				"metricValueForecast": 3330.5,
				"latlng": [
					4.570868,
					-74.297333
				],
				"country": "Colombia"
			},
			{
				"metricValueCurrent": 114.3,
				"metricValueForecast": 354.7,
				"latlng": [
					45.1,
					15.2
				],
				"country": "Croatia"
			},
			{
				"metricValueCurrent": 556.7,
				"metricValueForecast": 697.8,
				"latlng": [
					49.81749199999999,
					15.472962
				],
				"country": "Czech Rep"
			},
			{
				"metricValueCurrent": 22388.5,
				"metricValueForecast": 29645.2,
				"latlng": [
					51.165691,
					10.451526
				],
				"country": "Germany"
			},
			{
				"metricValueCurrent": 1577.9,
				"metricValueForecast": 2100.5,
				"latlng": [
					56.26392,
					9.501785
				],
				"country": "Denmark"
			},
			{
				"metricValueCurrent": 257,
				"metricValueForecast": 898.8,
				"latlng": [
					18.735693,
					-70.162651
				],
				"country": "Dominican Rep"
			},
			{
				"metricValueCurrent": 186,
				"metricValueForecast": 254.3,
				"latlng": [
					-1.831239,
					-78.18340599999999
				],
				"country": "Ecuador"
			},
			{
				"metricValueCurrent": 243.9,
				"metricValueForecast": 491.6,
				"latlng": [
					26.820553,
					30.802498
				],
				"country": "Egypt"
			},
			{
				"metricValueCurrent": 9139.7,
				"metricValueForecast": 17041.1,
				"latlng": [
					40.46366700000001,
					-3.74922
				],
				"country": "Spain"
			},
			{
				"metricValueCurrent": 68.9,
				"metricValueForecast": 213.4,
				"latlng": [
					58.595272,
					25.013607
				],
				"country": "Estonia"
			},
			{
				"metricValueCurrent": 1437.9,
				"metricValueForecast": 2118.6,
				"latlng": [
					61.92410999999999,
					25.748151
				],
				"country": "Finland"
			},
			{
				"metricValueCurrent": 24764.9,
				"metricValueForecast": 31559.6,
				"latlng": [
					46.227638,
					2.213749
				],
				"country": "France"
			},
			{
				"metricValueCurrent": 25645.7,
				"metricValueForecast": 32017.3,
				"latlng": [
					55.378051,
					-3.435973
				],
				"country": "United Kingdom"
			},
			{
				"metricValueCurrent": 29.6,
				"metricValueForecast": 164.9,
				"latlng": [
					42.315407,
					43.35689199999999
				],
				"country": "Georgia"
			},
			{
				"metricValueCurrent": 1440.8,
				"metricValueForecast": 2607.3,
				"latlng": [
					39.074208,
					21.824312
				],
				"country": "Greece"
			},
			{
				"metricValueCurrent": 158.9,
				"metricValueForecast": 634.9,
				"latlng": [
					15.783471,
					-90.23075899999999
				],
				"country": "Guatemala"
			},
			{
				"metricValueCurrent": 1956.4,
				"metricValueForecast": 2666.5,
				"latlng": [
					22.396428,
					114.109497
				],
				"country": "Hong Kong"
			},
			{
				"metricValueCurrent": 340.9,
				"metricValueForecast": 656.9,
				"latlng": [
					47.162494,
					19.503304
				],
				"country": "Hungary"
			},
			{
				"metricValueCurrent": 1335.9,
				"metricValueForecast": 4054.2,
				"latlng": [
					-0.789275,
					113.921327
				],
				"country": "Indonesia"
			},
			{
				"metricValueCurrent": 1281.1,
				"metricValueForecast": 2011,
				"latlng": [
					53.41291,
					-8.24389
				],
				"country": "Ireland"
			},
			{
				"metricValueCurrent": 2356.5,
				"metricValueForecast": 8830.3,
				"latlng": [
					20.593684,
					78.96288
				],
				"country": "India"
			},
			{
				"metricValueCurrent": 229,
				"metricValueForecast": 321.7,
				"latlng": [
					32.427908,
					53.688046
				],
				"country": "Iran"
			},
			{
				"metricValueCurrent": 1428.4,
				"metricValueForecast": 2510,
				"latlng": [
					31.046051,
					34.851612
				],
				"country": "Israel"
			},
			{
				"metricValueCurrent": 22604.7,
				"metricValueForecast": 31253.2,
				"latlng": [
					41.87194,
					12.56738
				],
				"country": "Italy"
			},
			{
				"metricValueCurrent": 95.4,
				"metricValueForecast": 314.8,
				"latlng": [
					30.585164,
					36.238414
				],
				"country": "Jordan"
			},
			{
				"metricValueCurrent": 56090.9,
				"metricValueForecast": 59960.6,
				"latlng": [
					36.204824,
					138.252924
				],
				"country": "Japan"
			},
			{
				"metricValueCurrent": 103.3,
				"metricValueForecast": 591.9,
				"latlng": [
					48.019573,
					66.923684
				],
				"country": "Kazakhstan"
			},
			{
				"metricValueCurrent": 12836.1,
				"metricValueForecast": 21423.4,
				"latlng": [
					35.907757,
					127.766922
				],
				"country": "South Korea"
			},
			{
				"metricValueCurrent": 682.3,
				"metricValueForecast": 1491,
				"latlng": [
					29.31166,
					47.481766
				],
				"country": "Kuwait"
			},
			{
				"metricValueCurrent": 62.6,
				"metricValueForecast": 244,
				"latlng": [
					-0.023559,
					37.906193
				],
				"country": "Kenya"
			},
			{
				"metricValueCurrent": 62.5,
				"metricValueForecast": 192.1,
				"latlng": [
					56.879635,
					24.603189
				],
				"country": "Latvia"
			},
			{
				"metricValueCurrent": 75.9,
				"metricValueForecast": 244.6,
				"latlng": [
					55.169438,
					23.881275
				],
				"country": "Lithuania"
			},
			{
				"metricValueCurrent": 14,
				"metricValueForecast": 44.2,
				"latlng": [
					41.608635,
					21.745275
				],
				"country": "Macedonia"
			},
			{
				"metricValueCurrent": 269.5,
				"metricValueForecast": 827.9,
				"latlng": [
					31.791702,
					-7.092619999999999
				],
				"country": "Morocco"
			},
			{
				"metricValueCurrent": 2257.4,
				"metricValueForecast": 6205.2,
				"latlng": [
					23.634501,
					-102.552784
				],
				"country": "Mexico"
			},
			{
				"metricValueCurrent": 435.2,
				"metricValueForecast": 1851.3,
				"latlng": [
					4.210484,
					101.975766
				],
				"country": "Malaysia"
			},
			{
				"metricValueCurrent": 102,
				"metricValueForecast": 129.7,
				"latlng": [
					9.081999,
					8.675277
				],
				"country": "Nigeria"
			},
			{
				"metricValueCurrent": 6661.2,
				"metricValueForecast": 8062.9,
				"latlng": [
					52.132633,
					5.291265999999999
				],
				"country": "Netherlands"
			},
			{
				"metricValueCurrent": 1362.7,
				"metricValueForecast": 1763.3,
				"latlng": [
					60.47202399999999,
					8.468945999999999
				],
				"country": "Norway"
			},
			{
				"metricValueCurrent": 1597.1,
				"metricValueForecast": 2381.2,
				"latlng": [
					-40.900557,
					174.885971
				],
				"country": "New Zealand"
			},
			{
				"metricValueCurrent": 25.2,
				"metricValueForecast": 94.1,
				"latlng": [
					7.369721999999999,
					12.354722
				],
				"country": "Cameroon"
			},
			{
				"metricValueCurrent": 700.8,
				"metricValueForecast": 4172.1,
				"latlng": [
					12.879721,
					121.774017
				],
				"country": "Philippines"
			},
			{
				"metricValueCurrent": 353.3,
				"metricValueForecast": 2263.9,
				"latlng": [
					30.375321,
					69.34511599999999
				],
				"country": "Pakistan"
			},
			{
				"metricValueCurrent": 629.5,
				"metricValueForecast": 1770,
				"latlng": [
					51.919438,
					19.145136
				],
				"country": "Poland"
			},
			{
				"metricValueCurrent": 1299.4,
				"metricValueForecast": 2344.7,
				"latlng": [
					39.39987199999999,
					-8.224454
				],
				"country": "Portugal"
			},
			{
				"metricValueCurrent": 650.9,
				"metricValueForecast": 2100.6,
				"latlng": [
					-9.189967,
					-75.015152
				],
				"country": "Peru"
			},
			{
				"metricValueCurrent": 675.6,
				"metricValueForecast": 1280.2,
				"latlng": [
					25.354826,
					51.183884
				],
				"country": "Qatar"
			},
			{
				"metricValueCurrent": 161.6,
				"metricValueForecast": 584.9,
				"latlng": [
					9.748916999999999,
					-83.753428
				],
				"country": "Costa Rica"
			},
			{
				"metricValueCurrent": 249.4,
				"metricValueForecast": 1165.4,
				"latlng": [
					45.943161,
					24.96676
				],
				"country": "Romania"
			},
			{
				"metricValueCurrent": 646.1,
				"metricValueForecast": 1984.9,
				"latlng": [
					61.52401,
					105.318756
				],
				"country": "Russia"
			},
			{
				"metricValueCurrent": 1777.6,
				"metricValueForecast": 4167.6,
				"latlng": [
					23.885942,
					45.079162
				],
				"country": "Saudi Arabia"
			},
			{
				"metricValueCurrent": 2183.9,
				"metricValueForecast": 3090.3,
				"latlng": [
					60.12816100000001,
					18.643501
				],
				"country": "Sweden"
			},
			{
				"metricValueCurrent": 2009.2,
				"metricValueForecast": 2813.7,
				"latlng": [
					1.352083,
					103.819836
				],
				"country": "Singapore"
			},
			{
				"metricValueCurrent": 217.6,
				"metricValueForecast": 609.1,
				"latlng": [
					48.669026,
					19.699024
				],
				"country": "Slovakia"
			},
			{
				"metricValueCurrent": 154.4,
				"metricValueForecast": 323.3,
				"latlng": [
					46.151241,
					14.995463
				],
				"country": "Slovenia"
			},
			{
				"metricValueCurrent": 882.3,
				"metricValueForecast": 2752.2,
				"latlng": [
					15.870032,
					100.992541
				],
				"country": "Thailand"
			},
			{
				"metricValueCurrent": 36.4,
				"metricValueForecast": 271.9,
				"latlng": [
					38.969719,
					59.556278
				],
				"country": "Turkmenistan"
			},
			{
				"metricValueCurrent": 1693.3,
				"metricValueForecast": 5139.7,
				"latlng": [
					38.963745,
					35.243322
				],
				"country": "Turkey"
			},
			{
				"metricValueCurrent": 182.9,
				"metricValueForecast": 485.9,
				"latlng": [
					33.886917,
					9.537499
				],
				"country": "Tunisia"
			},
			{
				"metricValueCurrent": 5701.3,
				"metricValueForecast": 9379,
				"latlng": [
					23.69781,
					120.960515
				],
				"country": "Taiwan"
			},
			{
				"metricValueCurrent": 927.8,
				"metricValueForecast": 2421.8,
				"latlng": [
					23.424076,
					53.847818
				],
				"country": "United Arab Emirates"
			},
			{
				"metricValueCurrent": 38.5,
				"metricValueForecast": 121,
				"latlng": [
					48.379433,
					31.16558
				],
				"country": "Ukraine"
			},
			{
				"metricValueCurrent": 81279.2,
				"metricValueForecast": 110322.8,
				"latlng": [
					37.09024,
					-95.712891
				],
				"country": "USA"
			},
			{
				"metricValueCurrent": 187.7,
				"metricValueForecast": 529.9,
				"latlng": [
					-32.522779,
					-55.765835
				],
				"country": "Uruguay"
			},
			{
				"metricValueCurrent": 43.9,
				"metricValueForecast": 105.9,
				"latlng": [
					41.377491,
					64.585262
				],
				"country": "Uzbekistan"
			},
			{
				"metricValueCurrent": 322.8,
				"metricValueForecast": 1318,
				"latlng": [
					14.058324,
					108.277199
				],
				"country": "Vietnam"
			},
			{
				"metricValueCurrent": 873.9,
				"metricValueForecast": 2884.8,
				"latlng": [
					-30.559482,
					22.937506
				],
				"country": "South Africa"
			},
			{
				"metricValueCurrent": 42.6,
				"metricValueForecast": 214.1,
				"latlng": [
					44.016521,
					21.005859
				],
				"country": "Serbia"
			}
		],
		"current_year": "2016"
	},
	{
		"segment": "HNWIs",
		"forecast_year": "2030",
		"forecast_max": 38209.3,
		"unit": "Number of Adults, '000s",
		"current_max": 16875.4,
		"metrics": [
			{
				"metricValueCurrent": 2.2,
				"metricValueForecast": 7.7,
				"latlng": [
					40.143105,
					47.576927
				],
				"country": "Azerbaijan"
			},
			{
				"metricValueCurrent": 6,
				"metricValueForecast": 13,
				"latlng": [
					28.033886,
					1.659626
				],
				"country": "Algeria"
			},
			{
				"metricValueCurrent": 36.5,
				"metricValueForecast": 53.8,
				"latlng": [
					-38.416097,
					-63.61667199999999
				],
				"country": "Argentina"
			},
			{
				"metricValueCurrent": 144.1,
				"metricValueForecast": 293.7,
				"latlng": [
					47.516231,
					14.550072
				],
				"country": "Austria"
			},
			{
				"metricValueCurrent": 1046.7,
				"metricValueForecast": 3298.3,
				"latlng": [
					-25.274398,
					133.775136
				],
				"country": "Australia"
			},
			{
				"metricValueCurrent": 280.9,
				"metricValueForecast": 749.3,
				"latlng": [
					50.503887,
					4.469936
				],
				"country": "Belgium"
			},
			{
				"metricValueCurrent": 3.4,
				"metricValueForecast": 8.4,
				"latlng": [
					26.0667,
					50.5577
				],
				"country": "Bahrain"
			},
			{
				"metricValueCurrent": 0.7,
				"metricValueForecast": 3.5,
				"latlng": [
					53.709807,
					27.953389
				],
				"country": "Belarus"
			},
			{
				"metricValueCurrent": 138.4,
				"metricValueForecast": 306.2,
				"latlng": [
					-14.235004,
					-51.92528
				],
				"country": "Brazil"
			},
			{
				"metricValueCurrent": 0.7,
				"metricValueForecast": 3.9,
				"latlng": [
					43.915886,
					17.679076
				],
				"country": "Bosnia"
			},
			{
				"metricValueCurrent": 3.9,
				"metricValueForecast": 19.9,
				"latlng": [
					42.733883,
					25.48583
				],
				"country": "Bulgaria"
			},
			{
				"metricValueCurrent": 1.5,
				"metricValueForecast": 6.1,
				"latlng": [
					-16.290154,
					-63.58865299999999
				],
				"country": "Bolivia"
			},
			{
				"metricValueCurrent": 1214.2,
				"metricValueForecast": 3150.7,
				"latlng": [
					56.130366,
					-106.346771
				],
				"country": "Canada"
			},
			{
				"metricValueCurrent": 637.8,
				"metricValueForecast": 1116.5,
				"latlng": [
					46.818188,
					8.227511999999999
				],
				"country": "Switzerland"
			},
			{
				"metricValueCurrent": 47.1,
				"metricValueForecast": 131.5,
				"latlng": [
					-35.675147,
					-71.542969
				],
				"country": "Chile"
			},
			{
				"metricValueCurrent": 1115.5,
				"metricValueForecast": 4910.7,
				"latlng": [
					35.86166,
					104.195397
				],
				"country": "China"
			},
			{
				"metricValueCurrent": 35.7,
				"metricValueForecast": 159.9,
				"latlng": [
					4.570868,
					-74.297333
				],
				"country": "Colombia"
			},
			{
				"metricValueCurrent": 4.1,
				"metricValueForecast": 13.9,
				"latlng": [
					45.1,
					15.2
				],
				"country": "Croatia"
			},
			{
				"metricValueCurrent": 26.2,
				"metricValueForecast": 33.5,
				"latlng": [
					49.81749199999999,
					15.472962
				],
				"country": "Czech Rep"
			},
			{
				"metricValueCurrent": 1748.7,
				"metricValueForecast": 3529.9,
				"latlng": [
					51.165691,
					10.451526
				],
				"country": "Germany"
			},
			{
				"metricValueCurrent": 184.6,
				"metricValueForecast": 485.9,
				"latlng": [
					56.26392,
					9.501785
				],
				"country": "Denmark"
			},
			{
				"metricValueCurrent": 9.7,
				"metricValueForecast": 39.1,
				"latlng": [
					18.735693,
					-70.162651
				],
				"country": "Dominican Rep"
			},
			{
				"metricValueCurrent": 7.4,
				"metricValueForecast": 9.6,
				"latlng": [
					-1.831239,
					-78.18340599999999
				],
				"country": "Ecuador"
			},
			{
				"metricValueCurrent": 15.5,
				"metricValueForecast": 31.6,
				"latlng": [
					26.820553,
					30.802498
				],
				"country": "Egypt"
			},
			{
				"metricValueCurrent": 403.2,
				"metricValueForecast": 1108.4,
				"latlng": [
					40.46366700000001,
					-3.74922
				],
				"country": "Spain"
			},
			{
				"metricValueCurrent": 2.8,
				"metricValueForecast": 10.9,
				"latlng": [
					58.595272,
					25.013607
				],
				"country": "Estonia"
			},
			{
				"metricValueCurrent": 73,
				"metricValueForecast": 177.6,
				"latlng": [
					61.92410999999999,
					25.748151
				],
				"country": "Finland"
			},
			{
				"metricValueCurrent": 1851.9,
				"metricValueForecast": 6394.1,
				"latlng": [
					46.227638,
					2.213749
				],
				"country": "France"
			},
			{
				"metricValueCurrent": 2074.7,
				"metricValueForecast": 5167.7,
				"latlng": [
					55.378051,
					-3.435973
				],
				"country": "United Kingdom"
			},
			{
				"metricValueCurrent": 1,
				"metricValueForecast": 5.6,
				"latlng": [
					42.315407,
					43.35689199999999
				],
				"country": "Georgia"
			},
			{
				"metricValueCurrent": 57,
				"metricValueForecast": 133,
				"latlng": [
					39.074208,
					21.824312
				],
				"country": "Greece"
			},
			{
				"metricValueCurrent": 6.5,
				"metricValueForecast": 27.1,
				"latlng": [
					15.783471,
					-90.23075899999999
				],
				"country": "Guatemala"
			},
			{
				"metricValueCurrent": 278.4,
				"metricValueForecast": 591.6,
				"latlng": [
					22.396428,
					114.109497
				],
				"country": "Hong Kong"
			},
			{
				"metricValueCurrent": 11.9,
				"metricValueForecast": 24.6,
				"latlng": [
					47.162494,
					19.503304
				],
				"country": "Hungary"
			},
			{
				"metricValueCurrent": 82.2,
				"metricValueForecast": 248,
				"latlng": [
					-0.789275,
					113.921327
				],
				"country": "Indonesia"
			},
			{
				"metricValueCurrent": 83.6,
				"metricValueForecast": 237.8,
				"latlng": [
					53.41291,
					-8.24389
				],
				"country": "Ireland"
			},
			{
				"metricValueCurrent": 154.9,
				"metricValueForecast": 597.6,
				"latlng": [
					20.593684,
					78.96288
				],
				"country": "India"
			},
			{
				"metricValueCurrent": 7.6,
				"metricValueForecast": 11.2,
				"latlng": [
					32.427908,
					53.688046
				],
				"country": "Iran"
			},
			{
				"metricValueCurrent": 98,
				"metricValueForecast": 210.3,
				"latlng": [
					31.046051,
					34.851612
				],
				"country": "Israel"
			},
			{
				"metricValueCurrent": 1151.2,
				"metricValueForecast": 2927.9,
				"latlng": [
					41.87194,
					12.56738
				],
				"country": "Italy"
			},
			{
				"metricValueCurrent": 3.2,
				"metricValueForecast": 11,
				"latlng": [
					30.585164,
					36.238414
				],
				"country": "Jordan"
			},
			{
				"metricValueCurrent": 3248.4,
				"metricValueForecast": 5978.2,
				"latlng": [
					36.204824,
					138.252924
				],
				"country": "Japan"
			},
			{
				"metricValueCurrent": 7.2,
				"metricValueForecast": 43.8,
				"latlng": [
					48.019573,
					66.923684
				],
				"country": "Kazakhstan"
			},
			{
				"metricValueCurrent": 696.6,
				"metricValueForecast": 1740.9,
				"latlng": [
					35.907757,
					127.766922
				],
				"country": "South Korea"
			},
			{
				"metricValueCurrent": 39.9,
				"metricValueForecast": 135,
				"latlng": [
					29.31166,
					47.481766
				],
				"country": "Kuwait"
			},
			{
				"metricValueCurrent": 4.3,
				"metricValueForecast": 16.7,
				"latlng": [
					-0.023559,
					37.906193
				],
				"country": "Kenya"
			},
			{
				"metricValueCurrent": 2.2,
				"metricValueForecast": 7.5,
				"latlng": [
					56.879635,
					24.603189
				],
				"country": "Latvia"
			},
			{
				"metricValueCurrent": 2.9,
				"metricValueForecast": 10.7,
				"latlng": [
					55.169438,
					23.881275
				],
				"country": "Lithuania"
			},
			{
				"metricValueCurrent": 0.4,
				"metricValueForecast": 1.4,
				"latlng": [
					41.608635,
					21.745275
				],
				"country": "Macedonia"
			},
			{
				"metricValueCurrent": 17.6,
				"metricValueForecast": 55.1,
				"latlng": [
					31.791702,
					-7.092619999999999
				],
				"country": "Morocco"
			},
			{
				"metricValueCurrent": 115.7,
				"metricValueForecast": 347.5,
				"latlng": [
					23.634501,
					-102.552784
				],
				"country": "Mexico"
			},
			{
				"metricValueCurrent": 27.5,
				"metricValueForecast": 117.6,
				"latlng": [
					4.210484,
					101.975766
				],
				"country": "Malaysia"
			},
			{
				"metricValueCurrent": 6.1,
				"metricValueForecast": 7.8,
				"latlng": [
					9.081999,
					8.675277
				],
				"country": "Nigeria"
			},
			{
				"metricValueCurrent": 491.7,
				"metricValueForecast": 1049.2,
				"latlng": [
					52.132633,
					5.291265999999999
				],
				"country": "Netherlands"
			},
			{
				"metricValueCurrent": 165.7,
				"metricValueForecast": 300.1,
				"latlng": [
					60.47202399999999,
					8.468945999999999
				],
				"country": "Norway"
			},
			{
				"metricValueCurrent": 161.3,
				"metricValueForecast": 547.5,
				"latlng": [
					-40.900557,
					174.885971
				],
				"country": "New Zealand"
			},
			{
				"metricValueCurrent": 1.2,
				"metricValueForecast": 4.7,
				"latlng": [
					7.369721999999999,
					12.354722
				],
				"country": "Cameroon"
			},
			{
				"metricValueCurrent": 32.9,
				"metricValueForecast": 229.7,
				"latlng": [
					12.879721,
					121.774017
				],
				"country": "Philippines"
			},
			{
				"metricValueCurrent": 15.8,
				"metricValueForecast": 104.5,
				"latlng": [
					30.375321,
					69.34511599999999
				],
				"country": "Pakistan"
			},
			{
				"metricValueCurrent": 28.3,
				"metricValueForecast": 81.5,
				"latlng": [
					51.919438,
					19.145136
				],
				"country": "Poland"
			},
			{
				"metricValueCurrent": 63.8,
				"metricValueForecast": 173.9,
				"latlng": [
					39.39987199999999,
					-8.224454
				],
				"country": "Portugal"
			},
			{
				"metricValueCurrent": 34.8,
				"metricValueForecast": 128.2,
				"latlng": [
					-9.189967,
					-75.015152
				],
				"country": "Peru"
			},
			{
				"metricValueCurrent": 38,
				"metricValueForecast": 84.3,
				"latlng": [
					25.354826,
					51.183884
				],
				"country": "Qatar"
			},
			{
				"metricValueCurrent": 6.4,
				"metricValueForecast": 27.6,
				"latlng": [
					9.748916999999999,
					-83.753428
				],
				"country": "Costa Rica"
			},
			{
				"metricValueCurrent": 11.6,
				"metricValueForecast": 58.6,
				"latlng": [
					45.943161,
					24.96676
				],
				"country": "Romania"
			},
			{
				"metricValueCurrent": 56.6,
				"metricValueForecast": 176.9,
				"latlng": [
					61.52401,
					105.318756
				],
				"country": "Russia"
			},
			{
				"metricValueCurrent": 79.3,
				"metricValueForecast": 222.9,
				"latlng": [
					23.885942,
					45.079162
				],
				"country": "Saudi Arabia"
			},
			{
				"metricValueCurrent": 282.1,
				"metricValueForecast": 618.3,
				"latlng": [
					60.12816100000001,
					18.643501
				],
				"country": "Sweden"
			},
			{
				"metricValueCurrent": 175.7,
				"metricValueForecast": 398.7,
				"latlng": [
					1.352083,
					103.819836
				],
				"country": "Singapore"
			},
			{
				"metricValueCurrent": 7.2,
				"metricValueForecast": 22,
				"latlng": [
					48.669026,
					19.699024
				],
				"country": "Slovakia"
			},
			{
				"metricValueCurrent": 5.2,
				"metricValueForecast": 12.7,
				"latlng": [
					46.151241,
					14.995463
				],
				"country": "Slovenia"
			},
			{
				"metricValueCurrent": 44.9,
				"metricValueForecast": 166.5,
				"latlng": [
					15.870032,
					100.992541
				],
				"country": "Thailand"
			},
			{
				"metricValueCurrent": 3,
				"metricValueForecast": 23.4,
				"latlng": [
					38.969719,
					59.556278
				],
				"country": "Turkmenistan"
			},
			{
				"metricValueCurrent": 111.7,
				"metricValueForecast": 355.8,
				"latlng": [
					38.963745,
					35.243322
				],
				"country": "Turkey"
			},
			{
				"metricValueCurrent": 7.9,
				"metricValueForecast": 21.9,
				"latlng": [
					33.886917,
					9.537499
				],
				"country": "Tunisia"
			},
			{
				"metricValueCurrent": 343.1,
				"metricValueForecast": 827,
				"latlng": [
					23.69781,
					120.960515
				],
				"country": "Taiwan"
			},
			{
				"metricValueCurrent": 45.8,
				"metricValueForecast": 142.8,
				"latlng": [
					23.424076,
					53.847818
				],
				"country": "United Arab Emirates"
			},
			{
				"metricValueCurrent": 3.4,
				"metricValueForecast": 10.6,
				"latlng": [
					48.379433,
					31.16558
				],
				"country": "Ukraine"
			},
			{
				"metricValueCurrent": 16875.4,
				"metricValueForecast": 38209.3,
				"latlng": [
					37.09024,
					-95.712891
				],
				"country": "USA"
			},
			{
				"metricValueCurrent": 7.2,
				"metricValueForecast": 24,
				"latlng": [
					-32.522779,
					-55.765835
				],
				"country": "Uruguay"
			},
			{
				"metricValueCurrent": 3,
				"metricValueForecast": 7.4,
				"latlng": [
					41.377491,
					64.585262
				],
				"country": "Uzbekistan"
			},
			{
				"metricValueCurrent": 16.2,
				"metricValueForecast": 67.8,
				"latlng": [
					14.058324,
					108.277199
				],
				"country": "Vietnam"
			},
			{
				"metricValueCurrent": 43.3,
				"metricValueForecast": 167.1,
				"latlng": [
					-30.559482,
					22.937506
				],
				"country": "South Africa"
			},
			{
				"metricValueCurrent": 1.1,
				"metricValueForecast": 6,
				"latlng": [
					44.016521,
					21.005859
				],
				"country": "Serbia"
			}
		],
		"current_year": "2016"
	},
	{
		"segment": "Ultra-HNWIs",
		"forecast_year": "2030",
		"forecast_max": 201.8,
		"unit": "Number of Adults, '000s",
		"current_max": 54.9,
		"metrics": [
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					40.143105,
					47.576927
				],
				"country": "Azerbaijan"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					28.033886,
					1.659626
				],
				"country": "Algeria"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.2,
				"latlng": [
					-38.416097,
					-63.61667199999999
				],
				"country": "Argentina"
			},
			{
				"metricValueCurrent": 0.4,
				"metricValueForecast": 1,
				"latlng": [
					47.516231,
					14.550072
				],
				"country": "Austria"
			},
			{
				"metricValueCurrent": 1.7,
				"metricValueForecast": 6.3,
				"latlng": [
					-25.274398,
					133.775136
				],
				"country": "Australia"
			},
			{
				"metricValueCurrent": 0.3,
				"metricValueForecast": 0.9,
				"latlng": [
					50.503887,
					4.469936
				],
				"country": "Belgium"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					26.0667,
					50.5577
				],
				"country": "Bahrain"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					53.709807,
					27.953389
				],
				"country": "Belarus"
			},
			{
				"metricValueCurrent": 1.2,
				"metricValueForecast": 2.6,
				"latlng": [
					-14.235004,
					-51.92528
				],
				"country": "Brazil"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					43.915886,
					17.679076
				],
				"country": "Bosnia"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					42.733883,
					25.48583
				],
				"country": "Bulgaria"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					-16.290154,
					-63.58865299999999
				],
				"country": "Bolivia"
			},
			{
				"metricValueCurrent": 2.7,
				"metricValueForecast": 8.5,
				"latlng": [
					56.130366,
					-106.346771
				],
				"country": "Canada"
			},
			{
				"metricValueCurrent": 2.3,
				"metricValueForecast": 4.8,
				"latlng": [
					46.818188,
					8.227511999999999
				],
				"country": "Switzerland"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.6,
				"latlng": [
					-35.675147,
					-71.542969
				],
				"country": "Chile"
			},
			{
				"metricValueCurrent": 4.4,
				"metricValueForecast": 19,
				"latlng": [
					35.86166,
					104.195397
				],
				"country": "China"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.7,
				"latlng": [
					4.570868,
					-74.297333
				],
				"country": "Colombia"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					45.1,
					15.2
				],
				"country": "Croatia"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.2,
				"latlng": [
					49.81749199999999,
					15.472962
				],
				"country": "Czech Rep"
			},
			{
				"metricValueCurrent": 4.4,
				"metricValueForecast": 9.8,
				"latlng": [
					51.165691,
					10.451526
				],
				"country": "Germany"
			},
			{
				"metricValueCurrent": 0.5,
				"metricValueForecast": 1.7,
				"latlng": [
					56.26392,
					9.501785
				],
				"country": "Denmark"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					18.735693,
					-70.162651
				],
				"country": "Dominican Rep"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					-1.831239,
					-78.18340599999999
				],
				"country": "Ecuador"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.3,
				"latlng": [
					26.820553,
					30.802498
				],
				"country": "Egypt"
			},
			{
				"metricValueCurrent": 0.9,
				"metricValueForecast": 2.6,
				"latlng": [
					40.46366700000001,
					-3.74922
				],
				"country": "Spain"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					58.595272,
					25.013607
				],
				"country": "Estonia"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.4,
				"latlng": [
					61.92410999999999,
					25.748151
				],
				"country": "Finland"
			},
			{
				"metricValueCurrent": 1.9,
				"metricValueForecast": 8.1,
				"latlng": [
					46.227638,
					2.213749
				],
				"country": "France"
			},
			{
				"metricValueCurrent": 3.6,
				"metricValueForecast": 10.3,
				"latlng": [
					55.378051,
					-3.435973
				],
				"country": "United Kingdom"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					42.315407,
					43.35689199999999
				],
				"country": "Georgia"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.4,
				"latlng": [
					39.074208,
					21.824312
				],
				"country": "Greece"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					15.783471,
					-90.23075899999999
				],
				"country": "Guatemala"
			},
			{
				"metricValueCurrent": 1.8,
				"metricValueForecast": 5,
				"latlng": [
					22.396428,
					114.109497
				],
				"country": "Hong Kong"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					47.162494,
					19.503304
				],
				"country": "Hungary"
			},
			{
				"metricValueCurrent": 0.6,
				"metricValueForecast": 1.9,
				"latlng": [
					-0.789275,
					113.921327
				],
				"country": "Indonesia"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.8,
				"latlng": [
					53.41291,
					-8.24389
				],
				"country": "Ireland"
			},
			{
				"metricValueCurrent": 1.4,
				"metricValueForecast": 5.4,
				"latlng": [
					20.593684,
					78.96288
				],
				"country": "India"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					32.427908,
					53.688046
				],
				"country": "Iran"
			},
			{
				"metricValueCurrent": 0.5,
				"metricValueForecast": 1.2,
				"latlng": [
					31.046051,
					34.851612
				],
				"country": "Israel"
			},
			{
				"metricValueCurrent": 1.6,
				"metricValueForecast": 4.4,
				"latlng": [
					41.87194,
					12.56738
				],
				"country": "Italy"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					30.585164,
					36.238414
				],
				"country": "Jordan"
			},
			{
				"metricValueCurrent": 3.3,
				"metricValueForecast": 7.3,
				"latlng": [
					36.204824,
					138.252924
				],
				"country": "Japan"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.4,
				"latlng": [
					48.019573,
					66.923684
				],
				"country": "Kazakhstan"
			},
			{
				"metricValueCurrent": 2.5,
				"metricValueForecast": 6.6,
				"latlng": [
					35.907757,
					127.766922
				],
				"country": "South Korea"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.5,
				"latlng": [
					29.31166,
					47.481766
				],
				"country": "Kuwait"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.2,
				"latlng": [
					-0.023559,
					37.906193
				],
				"country": "Kenya"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					56.879635,
					24.603189
				],
				"country": "Latvia"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					55.169438,
					23.881275
				],
				"country": "Lithuania"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					41.608635,
					21.745275
				],
				"country": "Macedonia"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.5,
				"latlng": [
					31.791702,
					-7.092619999999999
				],
				"country": "Morocco"
			},
			{
				"metricValueCurrent": 0.6,
				"metricValueForecast": 1.7,
				"latlng": [
					23.634501,
					-102.552784
				],
				"country": "Mexico"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.9,
				"latlng": [
					4.210484,
					101.975766
				],
				"country": "Malaysia"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					9.081999,
					8.675277
				],
				"country": "Nigeria"
			},
			{
				"metricValueCurrent": 0.6,
				"metricValueForecast": 1.5,
				"latlng": [
					52.132633,
					5.291265999999999
				],
				"country": "Netherlands"
			},
			{
				"metricValueCurrent": 0.3,
				"metricValueForecast": 0.8,
				"latlng": [
					60.47202399999999,
					8.468945999999999
				],
				"country": "Norway"
			},
			{
				"metricValueCurrent": 0.5,
				"metricValueForecast": 2,
				"latlng": [
					-40.900557,
					174.885971
				],
				"country": "New Zealand"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					7.369721999999999,
					12.354722
				],
				"country": "Cameroon"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 1,
				"latlng": [
					12.879721,
					121.774017
				],
				"country": "Philippines"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.5,
				"latlng": [
					30.375321,
					69.34511599999999
				],
				"country": "Pakistan"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.4,
				"latlng": [
					51.919438,
					19.145136
				],
				"country": "Poland"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.4,
				"latlng": [
					39.39987199999999,
					-8.224454
				],
				"country": "Portugal"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.6,
				"latlng": [
					-9.189967,
					-75.015152
				],
				"country": "Peru"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.3,
				"latlng": [
					25.354826,
					51.183884
				],
				"country": "Qatar"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					9.748916999999999,
					-83.753428
				],
				"country": "Costa Rica"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.3,
				"latlng": [
					45.943161,
					24.96676
				],
				"country": "Romania"
			},
			{
				"metricValueCurrent": 0.8,
				"metricValueForecast": 2.4,
				"latlng": [
					61.52401,
					105.318756
				],
				"country": "Russia"
			},
			{
				"metricValueCurrent": 0.3,
				"metricValueForecast": 0.8,
				"latlng": [
					23.885942,
					45.079162
				],
				"country": "Saudi Arabia"
			},
			{
				"metricValueCurrent": 0.4,
				"metricValueForecast": 1.4,
				"latlng": [
					60.12816100000001,
					18.643501
				],
				"country": "Sweden"
			},
			{
				"metricValueCurrent": 0.5,
				"metricValueForecast": 1.3,
				"latlng": [
					1.352083,
					103.819836
				],
				"country": "Singapore"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					48.669026,
					19.699024
				],
				"country": "Slovakia"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					46.151241,
					14.995463
				],
				"country": "Slovenia"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.7,
				"latlng": [
					15.870032,
					100.992541
				],
				"country": "Thailand"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.3,
				"latlng": [
					38.969719,
					59.556278
				],
				"country": "Turkmenistan"
			},
			{
				"metricValueCurrent": 0.9,
				"metricValueForecast": 3,
				"latlng": [
					38.963745,
					35.243322
				],
				"country": "Turkey"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					33.886917,
					9.537499
				],
				"country": "Tunisia"
			},
			{
				"metricValueCurrent": 1.5,
				"metricValueForecast": 3.7,
				"latlng": [
					23.69781,
					120.960515
				],
				"country": "Taiwan"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.7,
				"latlng": [
					23.424076,
					53.847818
				],
				"country": "United Arab Emirates"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					48.379433,
					31.16558
				],
				"country": "Ukraine"
			},
			{
				"metricValueCurrent": 54.9,
				"metricValueForecast": 201.8,
				"latlng": [
					37.09024,
					-95.712891
				],
				"country": "USA"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					-32.522779,
					-55.765835
				],
				"country": "Uruguay"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0.1,
				"latlng": [
					41.377491,
					64.585262
				],
				"country": "Uzbekistan"
			},
			{
				"metricValueCurrent": 0.1,
				"metricValueForecast": 0.4,
				"latlng": [
					14.058324,
					108.277199
				],
				"country": "Vietnam"
			},
			{
				"metricValueCurrent": 0.2,
				"metricValueForecast": 0.8,
				"latlng": [
					-30.559482,
					22.937506
				],
				"country": "South Africa"
			},
			{
				"metricValueCurrent": 0,
				"metricValueForecast": 0,
				"latlng": [
					44.016521,
					21.005859
				],
				"country": "Serbia"
			}
		],
		"current_year": "2016"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/app/services/data/data-segmented-countries.json
// module id = 111
// module chunks = 0